import apiConfig from './apiConfig'
import { getSessionData } from '../services/utilities/sessionManager'

export const eventManagerConfig = {
  url: apiConfig.firefly,
  apiKey: apiConfig.apiGatewayKey,
  eventManagerKey: 'internalapp',
  persistMethod: 'localStorage',
  retries: 1,
}

export const praxisEventManagerConfig = {
  url: apiConfig.analyticsUrl,
  appName: apiConfig.appName,
  apiKey: apiConfig.analyticsApiKey,
  fetch: (req) => {
    const sessionData = getSessionData()

    if (sessionData.sessionHash) {
      return req.text().then((body) => {
        try {
          const payload = JSON.parse(body)

          if (payload.client) {
            payload.client.session_id = sessionData.sessionHash
          } else {
            payload.client = {
              session_id: sessionData.sessionHash,
            }
          }

          const modifiedReq = new Request(req, {
            body: JSON.stringify(payload),
          })

          return fetch(modifiedReq)
        } catch (error) {
          console.error('[Analytics] Failed to modify request body:', error)
          return fetch(req)
        }
      })
    }

    return fetch(req)
  },
}
